// use to handle view state of sort filter slide out internally
import { ref } from 'vue';

const initialState = Object.freeze({
  sortBySelectedValue: '',
  facets: [],
});

const selections = ref({ ...initialState });

export default function useSortFilter() {
  const buildSections = (view) => {
    selections.value.sortBySelectedValue = view.sortBySelectedValue;
    selections.value.facets = JSON.parse(JSON.stringify(view.facets));
  };

  const updateSortBy = (value) => {
    selections.value.sortBySelectedValue = value;
  };

  const updateFacet = (criteria) => {
    // is this same as facetByName?
    const facet = selections.value.facets.filter((_facet) => _facet.name === criteria.name);
    if (facet.length > 0) {
      facet[0].selectedValues = criteria.selectedValues;
    }
  };

  const addCheckboxValue = (criteria) => {
    // is this same as facetByName?
    const facet = selections.value.facets.filter((_facet) => _facet.name === criteria.name);
    if (facet.length > 0) {
      facet[0].values.push(criteria.newValue);
    }
  };

  const facetByName = (name) => selections.value.facets.filter((facet) => facet.name === name)[0];

  const removeCheckBoxValuesByValue = (criteria) => {
    const facet = selections.value.facets.filter((_facet) => _facet.name === criteria.name);
    if (facet.length > 0) {
      facet[0].values = facet[0].values.filter((value) => value.value !== criteria.value);
    }
  };

  const resetSelections = () => {
    selections.value = { ...initialState };
  };

  const clearAllSelectedFacets = () => {
    selections.value.facets
      .filter((facet) => facet.selectedValues.length > 0)
      .forEach((facet) => {
        facet.selectedValues = [];
      });
  };

  return {
    addCheckboxValue,
    removeCheckBoxValuesByValue,
    resetSelections,
    clearAllSelectedFacets,
    updateSortBy,
    updateFacet,
    facetByName,
    buildSections,
    selections,
  };
}
